import {
    futureOrderDataType,
    futureTradeDataType,
    optionsTradesDataType,
    optionTradeDataType
} from '../pages/typings/options.typings'
import { findNearestNumber, getCurentOrderPricesFromData, findNearestNumberIndex, CalculateOptionPrice } from './tradepanel'
import BullCallSpread from '../assets/icons/optionsStrategy/BullCallSpread'
import BuyCall from '../assets/icons/optionsStrategy/BuyCall'
import SellPut from '../assets/icons/optionsStrategy/SellPut'
import BullPutSpread from '../assets/icons/optionsStrategy/BullPutSpread'
import CallRatioBackSpread from '../assets/icons/optionsStrategy/CallRatioBackSpread'
import LongCalendarWithCalls from '../assets/icons/optionsStrategy/LongCalendarWithCalls'
import BullCondor from '../assets/icons/optionsStrategy/BullCondor'
import BullButterfly from '../assets/icons/optionsStrategy/BullButterfly'
import RangeForward from '../assets/icons/optionsStrategy/RangeForward'
import LongSyntheticFuture from '../assets/icons/optionsStrategy/LongSyntheticFuture'
import BuyPut from '../assets/icons/optionsStrategy/BuyPut'
import SellCall from '../assets/icons/optionsStrategy/SellCall'
import BearCallSpread from '../assets/icons/optionsStrategy/BearCallSpread'
import BearPutSpread from '../assets/icons/optionsStrategy/BearPutSpread'
import PutRatioBackSpread from '../assets/icons/optionsStrategy/PutRatioBackSpread'
import LongCalendarWithPuts from '../assets/icons/optionsStrategy/LongCalendarWithPuts'
import BearCondor from '../assets/icons/optionsStrategy/BearCondor'
import BearButterfly from '../assets/icons/optionsStrategy/BearButterfly'
import RiskReversal from '../assets/icons/optionsStrategy/RiskReversal'
import ShortSyntheticFuture from '../assets/icons/optionsStrategy/ShortSyntheticFuture'
import ShortStraddle from '../assets/icons/optionsStrategy/ShortStraddle'
import IronButterfly from '../assets/icons/optionsStrategy/IronButterfly'
import ShortStrangle from '../assets/icons/optionsStrategy/ShortStrangle'
import ShortIronCondor from '../assets/icons/optionsStrategy/ShortIronCondor'
import Batman from '../assets/icons/optionsStrategy/Batman'
import JadeLizard from '../assets/icons/optionsStrategy/JadeLizard'
import ReverseJadeLizard from '../assets/icons/optionsStrategy/ReverseJadeLizard'
import { OrdersDataType, setBasketAnalyzeDetails, setBasketId, setOrderDataFunction } from '../reducer/orders.reducer'
import { v4 as uuid } from 'uuid'
import { WidgetListItems } from './sidebar'
import commonActions from '../actions/common.actions'
import { Dispatch } from 'redux'
import { OptionType, Security, SecurityCategory_CategoryCode } from '../proto/generated/security'
import { getSecurityAsync, getSecurityKey } from './security'
import { EqualityOperator, StrategyGroup } from '../components/strategyTemplate/StrategyTemplate.types'
import dayjs from 'dayjs'
import { TradeOrder } from '../reducer/strategyBuilder.reducer'
import { Position } from '../proto/generated/position'
import { PayoffLeg, PayoffProfitData } from '../components/payoffContainer/livePayoffContainer'
import { TransactionType } from '../proto/generated/order'

export enum StrategiesValue {
    Buy_Call = 'Buy Call',
    Sell_Put = 'Sell Put',
    Bull_Call_Spread = 'Bull Call Spread',
    Bull_Put_Spread = 'Bull Put Spread',
    Call_Ratio_Back_Spread = 'Call Ratio Back Spread',
    Long_Calendar_With_Calls = 'Long Calendar With Calls',
    Bull_Condor = 'Bull Condor',
    Bull_Butterfly = 'Bull Butterfly',
    Range_Forward = 'Range Forward',
    Long_Synthetic_Future = 'Long Synthetic Future',
    Buy_Put = 'Buy Put',
    Sell_Call = 'Sell Call',
    Bear_Call_Spread = 'Bear Call Spread',
    Bear_Put_Spread = 'Bear Put Spread',
    Put_Ratio_Back_Spread = 'Put Ratio Back Spread',
    Long_Calendar_With_Puts = 'Long Calendar With Puts',
    Bear_Condor = 'Bear Condor',
    Bear_Butterfly = 'Bear Butterfly',
    Risk_Reversal = 'Risk Reversal',
    Short_Synthetic_Future = 'Short Synthetic Future',
    Short_Straddle = 'Short Straddle',
    Iron_Butterfly = 'Iron Butterfly',
    Short_Strangle = 'Short Strangle',
    Short_Iron_Condor = 'Short Iron Condor',
    Batman = 'Batman',
    Jade_Lizard = 'Jade Lizard',
    Reverse_Jade_Lizard = 'Reverse Jade Lizard',
}

export const StrategiesValueMap: {
    [key: string]: string
} = {
    BuyCall: 'Buy Call',
    SellPut: 'Sell Put',
    BullCallSpread: 'Bull Call Spread',
    BullPutSpread: 'Bull Put Spread',
    CallRatioBackSpread: 'Call Ratio Back Spread',
    LongCalendarWithCalls: 'Long Calendar With Calls',
    BullCondor: 'Bull Condor',
    BullButterfly: 'Bull Butterfly',
    RangeForward: 'Range Forward',
    LongSyntheticFuture: 'Long Synthetic Future',
    BuyPut: 'Buy Put',
    SellCall: 'Sell Call',
    BearCallSpread: 'Bear Call Spread',
    BearPutSpread: 'Bear Put Spread',
    PutRatioBackSpread: 'Put Ratio Back Spread',
    LongCalendarWithPuts: 'Long Calendar With Puts',
    BearCondor: 'Bear Condor',
    BearButterfly: 'Bear Butterfly',
    RiskReversal: 'Risk Reversal',
    ShortSyntheticFuture: 'Short Synthetic Future',
    ShortStraddle: 'Short Straddle',
    IronButterfly: 'Iron Butterfly',
    ShortStrangle: 'Short Strangle',
    ShortIronCondor: 'Short Iron Condor',
    Batman: 'Batman',
    JadeLizard: 'Jade Lizard',
    ReverseJadeLizard: 'Reverse Jade Lizard'
}

export function getStrategyCodeFromValue(value: StrategiesValue): string {
    return (value as StrategiesValue).split(' ').join('')
}

export type orderStrategyType = {
    type: 'buy' | 'sell',
    quantity: number
} & ({
    callPut: 'call' | 'put',
    strikeData: optionTradeDataType
    contractType: 'OPTION'
} | {
    expiry: string,
    data: futureOrderDataType
    contractType: 'FUTURE'
})

export const calculateDifferenceInDays = (firstExpiry: string | number, secondExpiry: string | number) => {
    const d1 = dayjs(firstExpiry).startOf("day")
    const d2 = dayjs(secondExpiry).startOf("day")
    return Math.abs(d1.diff(d2, "day"))
}

export const findGivenSdStrike = (atmStrikeData: optionTradeDataType, oneSdWidth: number, requiredSdWidth: number, optionsExpiries: optionsTradesDataType[], index: number) => {
    const requiredSd = atmStrikeData.strikeCol.strike + (requiredSdWidth * oneSdWidth)
    const nearest = findNearestNumber(optionsExpiries[index].trades.map(t => t.strikeCol.strike), Number(requiredSd.toFixed(0)))
    return optionsExpiries[index].trades.find(t => t.strikeCol.strike === nearest)
}

export const findGivenDiffStrike = (atmStrikeData: optionTradeDataType, diff: number, optionchainData: optionsTradesDataType) => {
    const requiredStrike = atmStrikeData.strikeCol.strike + diff
    const nearest = findNearestNumber(optionchainData.trades.map(t => t.strikeCol.strike), Number(requiredStrike.toFixed(0)))
    return optionchainData.trades.find(t => t.strikeCol.strike === nearest)
}

export const findNearestStrikeData = (strike: number, optionchainData: optionsTradesDataType) => {
    const nearest = findNearestNumber(optionchainData.trades.map(t => t.strikeCol.strike), Number(strike.toFixed(0)))
    return optionchainData.trades.find(t => t.strikeCol.strike === nearest)
}

export const findGivenPriceStrike = (premium: number, optionchainData: optionsTradesDataType, optionType: OptionType, operator: EqualityOperator) => {
    const pricesList = optionchainData.trades.map((t, i)=>{
        const option = optionType === OptionType.CE ? t.callOption : t.putOption
        return {
            price: (option?.ltp??0)/(t.callOption?.security.priceMultiplier??100),
            index: i
        }
    })
    const nearest = findNearestNumberIndex(pricesList, premium, operator)
    return optionchainData.trades[nearest]
}

export const findGivenDeltaStrike = (delta: number, optionchainData: optionsTradesDataType, optionType: OptionType, operator: EqualityOperator) => {
    const deltaList = optionchainData.trades.map((t, i)=>{
        const option = optionType === OptionType.CE ? t.callOption : t.putOption
        return {
            price: option?.optionGreeks.delta??0,
            index: i
        }
    })
    const nearest = findNearestNumberIndex(deltaList, delta, operator)
    return optionchainData.trades[nearest]
}

export const getOrderForStrategy = (value: StrategiesValue, atmStrikeData: optionTradeDataType, oneSdWidth: number, optionsExpiries: optionsTradesDataType[], index: number, setExpandedRows: (rows: string[]) => void): orderStrategyType[] => {
    switch (value) {
        case StrategiesValue.Buy_Call: {
            return [{ type: 'buy', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Sell_Put: {
            return [{ type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bull_Call_Spread: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            if (!halfSdStrike) break
            return [{ type: 'buy', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bull_Put_Spread: {
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)
            if (!mhalfSdStrike) break
            return [{ type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Call_Ratio_Back_Spread: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            if (!halfSdStrike) break
            return [{ type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 2, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Long_Calendar_With_Calls: {
            const monthExpiries = optionsExpiries.filter((option) => !option.expiration.weeklyExpiry && !option.derived)
            let firstIndex = index
            let secondIndex: number = -1
            monthExpiries.some((expiry) => {
                if (calculateDifferenceInDays(expiry.expirySeconds ?? '0', optionsExpiries[firstIndex].expirySeconds ?? '0') >= 14) {
                    secondIndex = Number(expiry.key)
                    return true
                }
                return false
            })
            if (!secondIndex || secondIndex === -1) {
                firstIndex = 0
                monthExpiries.some((expiry) => {
                    if (calculateDifferenceInDays(expiry.expirySeconds ?? '0', optionsExpiries[firstIndex].expirySeconds ?? '0') >= 14) {
                        secondIndex = Number(expiry.key)
                        return true
                    }
                    return false
                })
            }
            setExpandedRows([String(firstIndex), String(secondIndex)])

            const firstAtmStrike = optionsExpiries[firstIndex].trades.find(t => t.strikeCol.strike === optionsExpiries[firstIndex].atmStrike)
            if (!secondIndex || secondIndex === -1 || !firstAtmStrike) break

            const sdPercentFirst = optionsExpiries[firstIndex].standardDeviation
            const oneSdWidthFirst = (firstAtmStrike.strikeCol.strike * (sdPercentFirst / 100))

            const halfSdStrikeFirst = findGivenSdStrike(firstAtmStrike, oneSdWidthFirst, 0.5, optionsExpiries, firstIndex)

            const halfSdStrikeSecond = findGivenSdStrike(firstAtmStrike, oneSdWidthFirst, 0.5, optionsExpiries, secondIndex)

            if (!halfSdStrikeFirst || !halfSdStrikeSecond) break

            return [{
                type: 'sell',
                callPut: 'call',
                quantity: 1,
                strikeData: halfSdStrikeFirst,
                contractType: 'OPTION'
            },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrikeSecond, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bull_Condor: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            let percent = 1

            let oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while (halfSdStrike?.strikeCol.strike === oneSdStrike?.strikeCol.strike) {
                oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            let oneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while (oneSdStrike?.strikeCol.strike === oneHalfSdStrike?.strikeCol.strike) {
                oneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            let twoHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while (oneHalfSdStrike?.strikeCol.strike === twoHalfSdStrike?.strikeCol.strike) {
                twoHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            if (!halfSdStrike || !oneSdStrike || !oneHalfSdStrike || !twoHalfSdStrike) break

            return [{ type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: oneSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: oneHalfSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: twoHalfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bull_Butterfly: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            let percent = 1

            let oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while (halfSdStrike?.strikeCol.strike === oneSdStrike?.strikeCol.strike) {
                oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            let oneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while (oneSdStrike?.strikeCol.strike === oneHalfSdStrike?.strikeCol.strike) {
                oneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            if (!halfSdStrike || !oneSdStrike || !oneHalfSdStrike) break

            return [
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 2, strikeData: oneSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: oneHalfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Range_Forward: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)

            if (!halfSdStrike || !mhalfSdStrike) break

            return [
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Long_Synthetic_Future: {
            return [
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Buy_Put: {
            return [{ type: 'buy', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Sell_Call: {
            return [{ type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bear_Call_Spread: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            if (!halfSdStrike) break
            return [{ type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bear_Put_Spread: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)

            if (!halfSdStrike) break

            return [{ type: 'buy', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Put_Ratio_Back_Spread: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)
            if (!halfSdStrike) break
            return [{ type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 2, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Long_Calendar_With_Puts: {
            const monthExpiries = optionsExpiries.filter((option) => !option.expiration.weeklyExpiry && !option.derived)
            let firstIndex = index
            let secondIndex: number = -1
            monthExpiries.some((expiry) => {
                if (calculateDifferenceInDays(expiry.expirySeconds ?? '0', optionsExpiries[firstIndex].expirySeconds ?? '0') >= 14) {
                    secondIndex = Number(expiry.key)
                    return true
                }
                return false
            })
            if (!secondIndex || secondIndex === -1) {
                firstIndex = 0
                monthExpiries.some((expiry) => {
                    if (calculateDifferenceInDays(expiry.expirySeconds ?? '0', optionsExpiries[firstIndex].expirySeconds ?? '0') >= 14) {
                        secondIndex = Number(expiry.key)
                        return true
                    }
                    return false
                })
            }
            setExpandedRows([String(firstIndex), String(secondIndex)])

            const firstAtmStrike = optionsExpiries[firstIndex].trades.find(t => t.strikeCol.strike === optionsExpiries[firstIndex].atmStrike)
            if (!secondIndex || secondIndex === -1 || !firstAtmStrike) break

            const sdPercentFirst = optionsExpiries[firstIndex].standardDeviation
            const oneSdWidthFirst = (firstAtmStrike.strikeCol.strike * (sdPercentFirst / 100))

            const halfSdStrikeFirst = findGivenSdStrike(firstAtmStrike, oneSdWidthFirst, -0.5, optionsExpiries, firstIndex)

            const halfSdStrikeSecond = findGivenSdStrike(firstAtmStrike, oneSdWidthFirst, -0.5, optionsExpiries, secondIndex)

            if (!halfSdStrikeFirst || !halfSdStrikeSecond) break

            return [{
                type: 'sell',
                callPut: 'put',
                quantity: 1,
                strikeData: halfSdStrikeFirst,
                contractType: 'OPTION'
            },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: halfSdStrikeSecond, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bear_Condor: {
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)
            let percent = -1

            let moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent -= 0.5
            while (mhalfSdStrike?.strikeCol.strike === moneSdStrike?.strikeCol.strike) {
                moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent -= 0.5
            }

            let moneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent -= 0.5
            while (moneSdStrike?.strikeCol.strike === moneHalfSdStrike?.strikeCol.strike) {
                moneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent -= 0.5
            }

            let mTwoSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent -= 0.5
            while (moneHalfSdStrike?.strikeCol.strike === mTwoSdStrike?.strikeCol.strike) {
                mTwoSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent -= 0.5
            }

            if (!mhalfSdStrike || !moneSdStrike || !moneHalfSdStrike || !mTwoSdStrike) break

            return [{ type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: moneHalfSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: mTwoSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Bear_Butterfly: {
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)
            let percent = -1

            let moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent -= 0.5
            while (mhalfSdStrike?.strikeCol.strike === moneSdStrike?.strikeCol.strike) {
                moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent -= 0.5
            }

            let moneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent -= 0.5
            while (moneSdStrike?.strikeCol.strike === moneHalfSdStrike?.strikeCol.strike) {
                moneHalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent -= 0.5
            }

            if (!mhalfSdStrike || !moneSdStrike || !moneHalfSdStrike) break

            return [{ type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 2, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: moneHalfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Risk_Reversal: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)

            if (!halfSdStrike || !mhalfSdStrike) break

            return [
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Short_Synthetic_Future: {
            return [
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Short_Straddle: {
            return [
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' }]
        }
        case StrategiesValue.Iron_Butterfly: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)

            if (!halfSdStrike || !mhalfSdStrike) break

            return [
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: atmStrikeData, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Short_Strangle: {
            const halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 0.5, optionsExpiries, index)
            const mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -0.5, optionsExpiries, index)

            if (!halfSdStrike || !mhalfSdStrike) break

            return [
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Short_Iron_Condor: {
            let percent = 0.5
            let halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            let mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
            percent += 0.5
            while (halfSdStrike?.strikeCol.strike === mhalfSdStrike?.strikeCol.strike) {
                halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
                percent += 0.5
            }

            let moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
            let oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.5
            while ((halfSdStrike?.strikeCol.strike === oneSdStrike?.strikeCol.strike) || (mhalfSdStrike?.strikeCol.strike === moneSdStrike?.strikeCol.strike)) {
                moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
                oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.5
            }

            if (!halfSdStrike || !mhalfSdStrike || !moneSdStrike || !oneSdStrike) break

            return [
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: oneSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Batman: {
            let percent = 0.5
            let halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            let mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
            percent += 0.25
            while (halfSdStrike?.strikeCol.strike === mhalfSdStrike?.strikeCol.strike) {
                halfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                mhalfSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
                percent += 0.25
            }

            let moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
            let oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
            percent += 0.25
            while ((halfSdStrike?.strikeCol.strike === oneSdStrike?.strikeCol.strike) || (mhalfSdStrike?.strikeCol.strike === moneSdStrike?.strikeCol.strike)) {
                moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1 * percent, optionsExpiries, index)
                oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, percent, optionsExpiries, index)
                percent += 0.25
            }

            if (!halfSdStrike || !mhalfSdStrike || !moneSdStrike || !oneSdStrike) break

            return [
                { type: 'sell', callPut: 'put', quantity: 2, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: mhalfSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: halfSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 2, strikeData: oneSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Jade_Lizard: {
            const moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1, optionsExpiries, index)
            const oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 1, optionsExpiries, index)
            const oneQuaterSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 1.25, optionsExpiries, index)

            if (!moneSdStrike || !oneSdStrike || !oneQuaterSdStrike) break

            return [
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: oneSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'call', quantity: 1, strikeData: oneQuaterSdStrike, contractType: 'OPTION' }]
        }
        case StrategiesValue.Reverse_Jade_Lizard: {
            const moneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1, optionsExpiries, index)
            const oneSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, 1, optionsExpiries, index)
            const moneQuaterSdStrike = findGivenSdStrike(atmStrikeData, oneSdWidth, -1.25, optionsExpiries, index)

            if (!moneSdStrike || !oneSdStrike || !moneQuaterSdStrike) break

            return [
                { type: 'sell', callPut: 'put', quantity: 1, strikeData: moneSdStrike, contractType: 'OPTION' },
                { type: 'sell', callPut: 'call', quantity: 1, strikeData: oneSdStrike, contractType: 'OPTION' },
                { type: 'buy', callPut: 'put', quantity: 1, strikeData: moneQuaterSdStrike, contractType: 'OPTION' }]
        }
    }
    return []
}

export const getStrategyIconFromText = (text: string) => {
    if (text.endsWith('Buy Call')) return <BuyCall />
    else if (text.endsWith('Sell Put')) return <SellPut />
    else if (text.endsWith('Bull Call Spread')) return <BullCallSpread />
    else if (text.endsWith('Bull Put Spread')) return <BullPutSpread />
    else if (text.endsWith('Call Ratio Back Spread')) return <CallRatioBackSpread />
    else if (text.endsWith('Long Calender With Calls')) return <LongCalendarWithCalls />
    else if (text.endsWith('Bull Condor')) return <BullCondor />
    else if (text.endsWith('Bull Butterfly')) return <BullButterfly />
    else if (text.endsWith('Range Forward')) return <RangeForward />
    else if (text.endsWith('Long Synthetic Future')) return <LongSyntheticFuture />
    else if (text.endsWith('Buy Put')) return <BuyPut />
    else if (text.endsWith('Sell Call')) return <SellCall />
    else if (text.endsWith('Bear Call Spread')) return <BearCallSpread />
    else if (text.endsWith('Bear Put Spread')) return <BearPutSpread />
    else if (text.endsWith('Put Ratio Back Spread')) return <PutRatioBackSpread />
    else if (text.endsWith('Long Calender With Puts')) return <LongCalendarWithPuts />
    else if (text.endsWith('Bear Condor')) return <BearCondor />
    else if (text.endsWith('Bear Butterfly')) return <BearButterfly />
    else if (text.endsWith('Risk Reversal')) return <RiskReversal />
    else if (text.endsWith('Short Synthetic Future')) return <ShortSyntheticFuture />
    else if (text.endsWith('Short Straddle')) return <ShortStraddle />
    else if (text.endsWith('Iron Butterfly')) return <IronButterfly />
    else if (text.endsWith('Short Strangle')) return <ShortStrangle />
    else if (text.endsWith('Short Iron Condor')) return <ShortIronCondor />
    else if (text.endsWith('Batman')) return <Batman />
    else if (text.endsWith('Jade Lizard')) return <JadeLizard />
    else if (text.endsWith('Reverse Jade Lizard')) return <ReverseJadeLizard />
}

export const strategies = [
    {
        label: StrategiesValue.Buy_Call,
        group: StrategyGroup.BULLISH,
        icon: <BuyCall />,
        iconWithProps: (props: any) => (<BuyCall {...props} />),
        description: 'Naked long call in strongly bullish market'
    },
    {
        label: StrategiesValue.Sell_Put,
        group: StrategyGroup.BULLISH,
        icon: <SellPut />,
        iconWithProps: (props: any) => (<SellPut {...props} />),
        description: 'Write put to earn premium in bullish market'
    },
    {
        label: StrategiesValue.Bull_Call_Spread,
        group: StrategyGroup.BULLISH,
        icon: <BullCallSpread />,
        iconWithProps: (props: any) => (<BullCallSpread {...props} />),
        description: 'Strategy with limited risk and reward in mildly bullish market'
    },
    {
        label: StrategiesValue.Bull_Put_Spread,
        group: StrategyGroup.BULLISH,
        icon: <BullPutSpread />,
        iconWithProps: (props: any) => (<BullPutSpread {...props} />),
        description: 'Earn time decay in mildly bullish or sideway market'
    },
    {
        label: StrategiesValue.Call_Ratio_Back_Spread,
        group: StrategyGroup.BULLISH,
        icon: <CallRatioBackSpread />,
        iconWithProps: (props: any) => (<CallRatioBackSpread {...props} />),
        description: 'When a significant rise is expected in highly volatile market'
    },
    {
        label: StrategiesValue.Long_Calendar_With_Calls,
        group: StrategyGroup.BULLISH,
        icon: <LongCalendarWithCalls />,
        iconWithProps: (props: any) => (<LongCalendarWithCalls {...props} />),
        description: 'When moderate price movement is expected over a specific period'
    },
    {
        label: StrategiesValue.Bull_Condor,
        group: StrategyGroup.BULLISH,
        icon: <BullCondor />,
        iconWithProps: (props: any) => (<BullCondor {...props} />),
        description: 'When stock is expected to rally into a higher price bracket'
    },
    {
        label: StrategiesValue.Bull_Butterfly,
        group: StrategyGroup.BULLISH,
        icon: <BullButterfly />,
        iconWithProps: (props: any) => (<BullButterfly {...props} />),
        description: 'When stock is expected to rally to a particular high price'
    },
    {
        label: StrategiesValue.Range_Forward,
        group: StrategyGroup.BULLISH,
        icon: <RangeForward />,
        iconWithProps: (props: any) => (<RangeForward {...props} />),
        description: 'Zero cost range forward in bullish market'
    },
    {
        label: StrategiesValue.Long_Synthetic_Future,
        group: StrategyGroup.BULLISH,
        icon: <LongSyntheticFuture />,
        iconWithProps: (props: any) => (<LongSyntheticFuture {...props} />),
        description: 'Using call and put to mimic a long futures contract'
    },
    {
        label: StrategiesValue.Buy_Put,
        group: StrategyGroup.BEARISH,
        icon: <BuyPut />,
        iconWithProps: (props: any) => (<BuyPut {...props} />),
        description: 'Naked long put in strongly bearish market'
    },
    {
        label: StrategiesValue.Sell_Call,
        group: StrategyGroup.BEARISH,
        icon: <SellCall />,
        iconWithProps: (props: any) => (<SellCall {...props} />),
        description: 'Write call to earn premium in bearish market'
    },
    {
        label: StrategiesValue.Bear_Call_Spread,
        group: StrategyGroup.BEARISH,
        icon: <BearCallSpread />,
        iconWithProps: (props: any) => (<BearCallSpread {...props} />),
        description: 'Strategy with limited risk and reward in mildly bearish market'
    },
    {
        label: StrategiesValue.Bear_Put_Spread,
        value: 'Bear_Put_Spread',
        group: StrategyGroup.BEARISH,
        icon: <BearPutSpread />,
        iconWithProps: (props: any) => (<BearPutSpread {...props} />),
        description: 'Earn time decay in mildly bearish or sideway market'
    },
    {
        label: StrategiesValue.Put_Ratio_Back_Spread,
        value: 'Put_Ratio_Back_Spread',
        group: StrategyGroup.BEARISH,
        icon: <PutRatioBackSpread />,
        iconWithProps: (props: any) => (<PutRatioBackSpread {...props} />),
        description: 'When a significant drop is expected in highly volatile market'
    },
    {
        label: StrategiesValue.Long_Calendar_With_Puts,
        value: 'Long_Calendar_With_Puts',
        group: StrategyGroup.BEARISH,
        icon: <LongCalendarWithPuts />,
        iconWithProps: (props: any) => (<LongCalendarWithPuts {...props} />),
        description: 'When moderate price movement is expected over a specific period'
    },
    {
        label: StrategiesValue.Bear_Condor,
        value: 'Bear_Condor',
        group: StrategyGroup.BEARISH,
        icon: <BearCondor />,
        iconWithProps: (props: any) => (<BearCondor {...props} />),
        description: 'When stock is expected to rally into a lower price bracket'
    },
    {
        label: StrategiesValue.Bear_Butterfly,
        value: 'Bear_Butterfly',
        group: StrategyGroup.BEARISH,
        icon: <BearButterfly />,
        iconWithProps: (props: any) => (<BearButterfly {...props} />),
        description: 'When stock is expected to rally to a particular low price'
    },
    {
        label: StrategiesValue.Risk_Reversal,
        value: 'Risk_Reversal',
        group: StrategyGroup.BEARISH,
        icon: <RiskReversal />,
        iconWithProps: (props: any) => (<RiskReversal {...props} />),
        description: 'Zero cost risk reversal in bearish market'
    },
    {
        label: StrategiesValue.Short_Synthetic_Future,
        value: 'Short_Synthetic_Future',
        group: StrategyGroup.BEARISH,
        icon: <ShortSyntheticFuture />,
        iconWithProps: (props: any) => (<ShortSyntheticFuture {...props} />),
        description: 'Using call and put to mimic a short futures contract'
    },
    {
        label: StrategiesValue.Short_Straddle,
        value: 'Short_Straddle',
        group: StrategyGroup.NEUTRAL,
        icon: <ShortStraddle />,
        iconWithProps: (props: any) => (<ShortStraddle {...props} />),
        description: 'Earn time decay in less volatile neutral market'
    },
    {
        label: StrategiesValue.Iron_Butterfly,
        group: StrategyGroup.NEUTRAL,
        icon: <IronButterfly />,
        iconWithProps: (props: any) => (<IronButterfly {...props} />),
        description: 'Earn time decay with reduced risk in neutral market'
    },
    {
        label: StrategiesValue.Short_Strangle,
        group: StrategyGroup.NEUTRAL,
        icon: <ShortStrangle />,
        iconWithProps: (props: any) => (<ShortStrangle {...props} />),
        description: 'Earn time decay with higher probability in neutral market'
    },
    {
        label: StrategiesValue.Short_Iron_Condor,
        group: StrategyGroup.NEUTRAL,
        icon: <ShortIronCondor />,
        iconWithProps: (props: any) => (<ShortIronCondor {...props} />),
        description: 'Earn time decay with reduced risk and higher probability'
    },
    {
        label: StrategiesValue.Batman,
        value: 'Batman',
        group: StrategyGroup.NEUTRAL,
        icon: <Batman />,
        iconWithProps: (props: any) => (<Batman {...props} />),
        description: 'Combination of call ratio spread and put ratio spread'
    },
    {
        label: StrategiesValue.Jade_Lizard,
        value: 'Jade_Lizard',
        group: StrategyGroup.NEUTRAL,
        icon: <JadeLizard />,
        iconWithProps: (props: any) => (<JadeLizard {...props} />),
        description: 'Earn premium in mild bullish or neutral market'
    },
    {
        label: StrategiesValue.Reverse_Jade_Lizard,
        value: 'Reverse_Jade_Lizard',
        group: StrategyGroup.NEUTRAL,
        icon: <ReverseJadeLizard />,
        iconWithProps: (props: any) => (<ReverseJadeLizard {...props} />),
        description: 'Earn premium in mild bearish or neutral market'
    }
]

export const addStrategyOrder = async (orderStrategy: orderStrategyType[], rightSideWidget: WidgetListItems | null, dispatch: Dispatch, optionExpiries: optionsTradesDataType[], underlyingToken: string, doSetBasketId: boolean = false) => {
    const newOrders: OrdersDataType[] = []
    for (const strategy of orderStrategy) {
        let newOrder: any = {
            type: strategy.type,
            quantity: strategy.quantity,
            orderDetails: undefined,
            uuid: uuid(),
            contractType: strategy.contractType,
            visibility: true
        }
        if (strategy.contractType === 'OPTION') {
            const option = strategy.callPut === 'call' ? strategy.strikeData.callOption : strategy.strikeData.putOption
            const security = await getSecurityAsync(getSecurityKey(option?.security?.exchange ?? 0, option?.security?.code ?? ''))
            newOrder = {
                ...newOrder,
                security: security ?? option?.security,
                data: strategy.strikeData,
                callput: strategy.callPut,
                strike: strategy.strikeData.strikeCol.strike
            }
        } else if (strategy.contractType === 'FUTURE') {
            const security = await getSecurityAsync(getSecurityKey(strategy.data.security?.exchange ?? 0, strategy.data.security?.code ?? ''))
            newOrder = {
                ...newOrder,
                security: security ?? strategy.data.security,
                data: strategy.data
            }
        }
        newOrders.push(newOrder)
    }
    dispatch(setBasketAnalyzeDetails(undefined))
    const orderPrices = await getCurentOrderPricesFromData(newOrders, optionExpiries, underlyingToken, [])
    setOrderDataFunction({ orders: newOrders, resetPredefinedStrategy: false, resetOrderState: true, orderPrices })
    if (doSetBasketId) {
        dispatch(setBasketId({
            basketId: uuid()
        }))
    }
    if (rightSideWidget !== WidgetListItems.TRADE) commonActions.dispatchRightSideWidget(dispatch, WidgetListItems.TRADE)
}

export const getSortedTradedExpiries = async (tradeOrders: TradeOrder[], positions: Position[] = []) => {
    const expiries: number[] = [];
    for (const tO of tradeOrders) {
        const security = await getSecurityAsync(getSecurityKey(tO.security.exchange, tO.security.code));
        if (!security) continue;
        const exp = security.expiry?.expiry
        if (exp && !expiries.includes(exp)) expiries.push(exp)
    }

    for (const p of positions) {
        const sec = await getSecurityAsync(getSecurityKey(p.security.exchange, p.security.code));
        if (!sec) continue;
        const exp = sec.expiry?.expiry
        if (exp && !expiries.includes(exp)) expiries.push(exp)
    }
    return expiries.sort();
}


export const getPayoffProfitData = async (
    tradeOrders: TradeOrder[],
    positions: Position[],
    targetTimestamp: number,
    ivMultiplier: number,
    spotBasePrice: number,
    spotTargetPrice: number,
    optionsTradesData: optionsTradesDataType[],
    futuresTradesData: futureTradeDataType[],
    underlying: Security
) => {
    const profitData: PayoffProfitData[] = [];
    const tradeExpiries = await getSortedTradedExpiries(tradeOrders, positions)
    if (!tradeExpiries?.length) return {profitData: [], targetPnl: 0};
    const minExpiry = tradeExpiries[0];
    const optionsTradesDataMap: Record<number, optionsTradesDataType> = optionsTradesData.reduce((acc, o) => ({...acc, [o.expiration.expiry.expiry]: o}), {} as Record<number, optionsTradesDataType> )
    const futuresTradesDataMap: Record<number, futureTradeDataType> = futuresTradesData.reduce((acc, o) => ({...acc, [o.expiry]: o}), {} as Record<number, futureTradeDataType>)

    const nearestExpiryData = optionsTradesDataMap[minExpiry];

    if (!nearestExpiryData || nearestExpiryData.strikes.length < 2) return {profitData: [], targetPnl: 0};

    const strikes = [...nearestExpiryData.strikes].sort((a, b) => a.strike - b.strike);
    let stepUpValue = 100
    strikes.forEach(s=>{
        if(!Number.isInteger(s.strike/(underlying.priceMultiplier??100))) {
            const decimalPart = (s.strike/(underlying.priceMultiplier??100)) % 1
            if(decimalPart * 100 < stepUpValue) stepUpValue = decimalPart * 100
        }
    })


    const startPrice = strikes[0].strike;
    const endPrice = strikes[strikes.length - 1].strike;
    if (minExpiry < targetTimestamp) return {profitData: [], targetPnl: 0};

    for(let spotPrice = startPrice; spotPrice <= endPrice; spotPrice+=stepUpValue) {
        let expectedProfit = 0;
        let profitAtExpiry = 0;
        let existingPositionsProfit = 0;
        tradeOrders.forEach((o) => {
            if (!o.selected) return;
            const security = o.security;
            let entryPrice = o.price;
            const direction = o.transactionType === TransactionType.BUY ? 1 : -1;
            const quantity = direction*o.quantity;
            if (!security.expiry?.expiry) return;
            if (security.categoryCode === SecurityCategory_CategoryCode.FUTURES) {
                if (!entryPrice) entryPrice = 0;
                const [expected = 0, expiryProfit = 0] = getProfitsForSecurityAtDate(security, entryPrice, quantity, 0, 1, spotPrice, spotBasePrice, null)
                expectedProfit += expected;
                profitAtExpiry += expiryProfit;
            } else {
                const timeToExpiry = calculateDifferenceInDays(o.security.expiry?.expiry, targetTimestamp)
                const timeToNearestExpiry = calculateDifferenceInDays(minExpiry, targetTimestamp)
                const tradeData = optionsTradesDataMap[security.expiry.expiry]?.trades?.find(t => t.strikeCol.strike === security.strikePrice)
                let orderPrice = o.price || 0;
                const [expected = 0, expiryProfit = 0] = getProfitsForSecurityAtDate(security, orderPrice, quantity, timeToExpiry, timeToNearestExpiry, ivMultiplier, spotPrice, spotBasePrice, tradeData)
                expectedProfit += expected;
                profitAtExpiry += expiryProfit;
            }
        })

        for (const p of positions ?? []) {
            if (!p.security) continue;
            if (p.realisedProfit) {
                existingPositionsProfit += p.realisedProfit;
                profitAtExpiry += p.realisedProfit;
                expectedProfit += p.realisedProfit;
            }
            if (p.closePosition !== 0) {
                const security = await getSecurityAsync(getSecurityKey(p.security.exchange, p.security.code));
                const entryPrice = p.closePositionValue/p.closePosition;
                const quantity = p.closePosition;
                if (!security.expiry?.expiry) return;
                if (security.categoryCode === SecurityCategory_CategoryCode.FUTURES) {
                    const [expected = 0, expiryProfit = 0] = getProfitsForSecurityAtDate(security, entryPrice || 0, quantity, 0, 1, spotPrice, spotBasePrice, null)
                    expectedProfit += expected;
                    profitAtExpiry += expiryProfit;
                    existingPositionsProfit += expiryProfit;
                } else {
                    const timeToExpiry = calculateDifferenceInDays(security.expiry?.expiry, targetTimestamp)
                    const timeToNearestExpiry = calculateDifferenceInDays(minExpiry, targetTimestamp)
                    const tradeData = optionsTradesDataMap[security.expiry.expiry]?.trades?.find(t => t.strikeCol.strike === security.strikePrice)
                    const [expected = 0, expiryProfit = 0] = getProfitsForSecurityAtDate(security, entryPrice, quantity, timeToExpiry, timeToNearestExpiry, ivMultiplier, spotPrice, spotBasePrice, tradeData)
                    expectedProfit += expected;
                    profitAtExpiry += expiryProfit;
                    existingPositionsProfit += expiryProfit;
                }
            }
        }

        profitData.push({
            price: spotPrice/(underlying.priceMultiplier??100),
            expiryProfit: profitAtExpiry,
            expectedProfit,
            existingExpiryProfit: existingPositionsProfit
        })
    }

    let targetPnl = 0;

    tradeOrders.forEach((o) => {
        if (!o.selected) return;
        const security = o.security;
        let entryPrice = o.price;
        const direction = o.transactionType === TransactionType.BUY ? 1 : -1;
        const quantity = direction*o.quantity;
        if (!security.expiry?.expiry) return;
        if (security.categoryCode === SecurityCategory_CategoryCode.FUTURES) {
            if (!entryPrice) entryPrice = 0;
            const [expected = 0] = getProfitsForSecurityAtDate(security, entryPrice, quantity, 0, 1, spotTargetPrice, spotBasePrice, null)
            targetPnl += expected;
        } else {
            const timeToExpiry = calculateDifferenceInDays(o.security.expiry?.expiry, targetTimestamp)
            const timeToNearestExpiry = calculateDifferenceInDays(minExpiry, targetTimestamp)
            const tradeData = optionsTradesDataMap[security.expiry.expiry]?.trades?.find(t => t.strikeCol.strike === security.strikePrice)
            let orderPrice = o.price || 0;
            const [expected = 0] = getProfitsForSecurityAtDate(security, orderPrice, quantity, timeToExpiry, timeToNearestExpiry, ivMultiplier, spotTargetPrice, spotBasePrice, tradeData)
            targetPnl += expected;
        }
    })

    for (const p of positions ?? []) {
    if (!p.security) continue;
    if (p.closePosition === 0) {
        targetPnl += p.realisedProfit;
    } else {
        const security = await getSecurityAsync(getSecurityKey(p.security.exchange, p.security.code));
        const entryPrice = p.closePositionValue/p.closePosition;
        const quantity = p.closePosition;
        if (!security.expiry?.expiry) return;
        if (security.categoryCode === SecurityCategory_CategoryCode.FUTURES) {
            const [expected = 0] = getProfitsForSecurityAtDate(security, entryPrice || 0, quantity, 0, 1, spotTargetPrice, spotBasePrice, null)
            targetPnl += expected;
        } else {
            const timeToExpiry = calculateDifferenceInDays(security.expiry?.expiry, targetTimestamp)
            const timeToNearestExpiry = calculateDifferenceInDays(minExpiry, targetTimestamp)
            const tradeData = optionsTradesDataMap[security.expiry.expiry]?.trades?.find(t => t.strikeCol.strike === security.strikePrice)
            const [expected = 0] = getProfitsForSecurityAtDate(security, entryPrice, quantity, timeToExpiry, timeToNearestExpiry, ivMultiplier, spotTargetPrice, spotBasePrice, tradeData)
            targetPnl += expected;
        }
    }
}

    return {
        profitData,
        targetPnl: targetPnl/(underlying.priceMultiplier??100)
    };
};

export const getProfitsForSecurityAtDate = (
    security: Security,
    entryPrice: number,
    quantity: number, // -ve for sell, +ve for buy
    timeToExpiry: number,
    timeToNearestExpiry: number,
    ivMultiplier: number,
    targetPrice: number,
    spotBasePrice: number,
    optionTradeData?: optionTradeDataType
): [number, number] => {

    if (security.categoryCode !== SecurityCategory_CategoryCode.OPTIONS) {
        const delta = targetPrice - spotBasePrice;
        const profit = quantity*delta;
        return [profit, profit]
    }

    if (!optionTradeData) return [0, 0];

    const expectedPrice = getOptionExpectedPrice(security, timeToExpiry, ivMultiplier, targetPrice, optionTradeData)
    const expectedProfit = quantity*(expectedPrice - entryPrice);
    const priceAtExpiry = getOptionExpectedPrice(security, timeToExpiry - timeToNearestExpiry, ivMultiplier, targetPrice, optionTradeData);
    const profitAtExpiry = quantity*(priceAtExpiry - entryPrice)
    return [expectedProfit, profitAtExpiry];
}


export const getOptionExpectedPrice = (
    security: Security,
    timeToExpiry: number,
    ivMultiplier: number,
    spotPrice: number,
    optionTradeData: optionTradeDataType
) => {
    if (security.categoryCode !== SecurityCategory_CategoryCode.OPTIONS) return spotPrice;
    if (!optionTradeData) return 0;
    const priceMultiplier = security?.priceMultiplier ?? 100;
    
    const callOption = security.optionType === OptionType.CE;
    const option = callOption ? optionTradeData.callOption : optionTradeData.putOption
    if (timeToExpiry === 0) {
        return callOption ? Math.max(0, spotPrice - security.strikePrice) : Math.max(0, security.strikePrice - spotPrice);
    }
    return CalculateOptionPrice(spotPrice/priceMultiplier, security?.strikePrice/priceMultiplier, 0.1, timeToExpiry/365,  option?.impliedVolatility*ivMultiplier, callOption )*priceMultiplier
}

export const getPayoffLegs = async (tradeOrders: TradeOrder[], positions: Position[]) => {
    const payoffLegs: PayoffLeg[] = [];
    const linkedOrderIds: string[] = []

    for (const p of positions ?? []) {
        // Skip fully squared-off positions; they carry no open quantity and
        // should not surface a leg/tag on the payoff graph.
        if (!p.closePosition) continue
        const security = await getSecurityAsync(getSecurityKey(p.security.exchange, p.security.code))
        const pTransactionType = p.closePosition < 0 ? TransactionType.SELL : TransactionType.BUY
        const exactSecurityOrder = tradeOrders.find(t=>{
            return t.security.code===security.code && Math.abs(p.closePosition) === Math.abs(t.quantity) && pTransactionType !==t.transactionType && !linkedOrderIds.includes(t.clientOrderId)
        })
        
        const obj: PayoffLeg = {
            id: `${p.basketId}-${getSecurityKey(p.security.exchange, p.security.code)}`,
            security,
            quantity: p.closePosition,
            readonly: true,
            type: "position",
            entryPrice: (p.closePositionValue/p.closePosition)
        }

        if(exactSecurityOrder) {
            linkedOrderIds.push(exactSecurityOrder.clientOrderId)
            obj.linkedOrders = [exactSecurityOrder.clientOrderId]
        }

        payoffLegs.push(
            obj
        )
    }

    tradeOrders?.forEach((to) => {
        if(!linkedOrderIds.includes(to.clientOrderId)) {
            payoffLegs.push({
                id: to.clientOrderId,
                security: to.security,
                quantity: (to.transactionType === TransactionType.BUY ? 1 : -1)*to.quantity,
                readonly: false,
                type: "order",
                entryPrice: to.price
            })
        }
    })

    return payoffLegs;
}

